import { createContext } from 'react';

const Context = createContext();

export default Context;
export const { Provider, Consumer } = Context;
